import { useEffect } from "react";
import HoroscopeByZodiac from "./HoroscopeByZodiac";
import HoroscopeByAscendant from "./HoroscopeByAscendant";
import LuckyNameChecker from "./LuckyNameChecker";
import TarotCardReading from "./TarotCardReading";
import NameNumerology from "./NameNumerology";
import SectionHeaderHoro from "../header/SectionHeaderHoro";
import ProfileWithBackButtonHeader from "../header/ProfileWithBackButtonHeader";

export default function App() {
  return (
    <div>
      {/* Header with Back Button */}
      <ProfileWithBackButtonHeader />

      {/* Section Header */}
      <div className="bg-[#f6f6f6] w-full px-5 xs:px-2">
        <SectionHeaderHoro
          className="pt-4 text-lg"
          name="🌟 มหาลัคนาพลัส"
          eventSection={true}
          seniorLayout={false}
        />
        <HoroscopeByAscendant />

        <LuckyNameChecker />

        <HoroscopeByZodiac />
        {/*  
        <NameNumerology />
        <TarotCardReading />
        */}
      </div>
    </div>
  );
}
